var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list"},_vm._l((_vm.items),function(item,index){return (item.uuid || item.id)?_c('div',{key:item.uuid || ((item.id) + "-" + index),staticClass:"product-item"},[_vm._t("default",null,{item:item})],2):_vm._e()}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8467040","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductCategoryMobile/ProductList/ProductListItems.vue
// module id = null
// module chunks = 